export const Roles = Object.freeze({
  ADMIN: 1,
  CREATOR: 2,
  MANAGER: 3,
  MANAGER_LIMITED: 4,
  VIEWER: 5,
  VIEWER_LIMITED: 6,
  RIGHT_HOLDER: 11,
});
